export default __webpack_public_path__ + "static/media/recipe.12cd2bd1.svg";